import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tv-program-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TvProgramCard = _resolveComponent("TvProgramCard")!
  const _component_TvProgramModal = _resolveComponent("TvProgramModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "data-slider-pane": "",
      class: _normalizeClass(["tv-program-list__row", {
        'tv-program-list__row--slider': _ctx.showSlider
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tvPrograms, (tvProgram, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["tv-program-list__col", {
          'tv-program-list__col--2': _ctx.maxCols === 2,
          'tv-program-list__col--3': _ctx.maxCols === 3,
          'tv-program-list__col--4': _ctx.maxCols === 4
        }])
        }, [
          _createVNode(_component_TvProgramCard, {
            "tv-program": tvProgram,
            "item-length": _ctx.itemLength,
            "first-date": _ctx.firstDate
          }, null, 8, ["tv-program", "item-length", "first-date"])
        ], 2))
      }), 128))
    ], 2),
    (_ctx.programInfo)
      ? (_openBlock(), _createBlock(_component_TvProgramModal, {
          key: 0,
          "program-info": _ctx.programInfo,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.programInfo = null))
        }, null, 8, ["program-info"]))
      : _createCommentVNode("", true)
  ]))
}